module.exports = __webpack_public_path__ + "static/media/7.ac6d68d3.png";